import Vue from 'vue';
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);
import {validationMixin} from 'vuelidate';
import {required, email} from 'vuelidate/lib/validators';

import {mapActions, mapGetters, mapMutations} from "vuex";

import {
    REMOVE_ITEM_FROM_BASKET,
    SHOW_POPUP_REMOVE_FROM_BASKET
} from '@/store/mutation-types'

export default {
    name: 'remove-item-from-basket',
    mixin: [validationMixin],
    computed: {
        ...mapGetters({
           item: 'basket/removeDataItem'
        })
    },
    methods: {
        ...mapMutations({
            remove: `basket/${REMOVE_ITEM_FROM_BASKET}`,
            changeRemovePopup: `basket/${SHOW_POPUP_REMOVE_FROM_BASKET}`,
        }),
        removeItem() {
            this.changeRemovePopup(false);
            this.remove(this.item);
            this.$toasted.success(this.$t('successDeleteFromBasket')).goAway(5000);
        },
        cancel(){
            this.changeRemovePopup(false)
        }
    },
    destroyed() {

    }
}
